import React from 'react';

export default function StoreLinks() {
  return <div className="dl-store-row">
    <a className="dl-store-link" href="https://apps.apple.com/pl/app/vroom/id6764661186?l=pl" target="_blank" rel="noopener noreferrer" aria-label="Pobierz VROOM z App Store">
      <svg viewBox="0 0 24 28" aria-hidden="true"><path fill="currentColor" d="M18 14c0-3 2.4-4.5 2.5-4.6-1.4-2-3.5-2.3-4.3-2.3-1.8-.2-3.5 1.1-4.4 1.1-.9 0-2.3-1.1-3.8-1-2 0-3.9 1.2-5 3-2.1 3.6-.5 9 1.5 12 1 1.4 2.1 2.9 3.7 2.8 1.5 0 2.1-.9 4-.9 1.8 0 2.4.9 4 .9 1.6 0 2.6-1.4 3.5-2.8 1.1-1.6 1.6-3.2 1.6-3.3-.1 0-3.3-1.3-3.3-4.9ZM15 5.2c.8-1 1.4-2.4 1.3-3.8-1.2.1-2.7.8-3.6 1.8-.8.9-1.5 2.3-1.3 3.6 1.3.1 2.7-.7 3.6-1.6Z" /></svg>
      <span><small>Pobierz w</small><strong>App Store</strong></span>
    </a>
    <a className="dl-store-link" href="https://play.google.com/store/apps/details?id=com.lexuuw.vroom.app" target="_blank" rel="noopener noreferrer" aria-label="Pobierz VROOM z Google Play">
      <svg viewBox="0 0 28 30" aria-hidden="true"><path fill="#4ac7f2" d="M2 2 16 15 2 28Z"/><path fill="#41d18b" d="m2 2 18 10-4 3Z"/><path fill="#ffcf47" d="m20 12 6 3-6 3-4-3Z"/><path fill="#f76672" d="m2 28 14-13 4 3Z"/></svg>
      <span><small>Pobierz z</small><strong>Google Play</strong></span>
    </a>
  </div>;
}

